// extracted by mini-css-extract-plugin
export default {"wrapper":"TabButton_wrapper__Srhwp","active":"TabButton_active__VxA5b","dark":"TabButton_dark__5w63j"};